import { Native } from "../platform/android/nativeBridge";
import { NATIVE_EVENTS } from "../platform/android/nativeMethods";
import { onNativeEvent } from "../platform/android/nativeEventBus";

let isOnlineGlobal = window?.navigator?.onLine;
const listeners = new Set();

let isTrackingStarted = false;
let nativeEventListenerCleanup = null;

const notify = () => listeners.forEach((fn) => fn(isOnlineGlobal));

export const subscribeToNetwork = (fn) => {
  listeners.add(fn);
  if (listeners.size === 1) {
    startNetworkTracking();
  }
  return () => {
    listeners.delete(fn);
    if (listeners.size === 0) {
      stopNetworkTracking();
    }
  };
};

const updateStatus = (result) => {
  let parsed = result;
  if (typeof result === "string") {
    try {
      parsed = JSON.parse(result);
    } catch {
      parsed = result;
    }
  }
  let status;
  if (typeof parsed?.isOnline === "boolean") {
    status = parsed.isOnline;
  } else if (typeof parsed?.success === "boolean") {
    status = parsed.success;
  } else if (typeof parsed === "boolean") {
    status = parsed;
  } else if (parsed === "true" || parsed === "false") {
    status = parsed === "true";
  } else {
    return;
  }

  if (status !== isOnlineGlobal) {
    isOnlineGlobal = status;
    notify();
  }
};

export const startNetworkTracking = () => {
  if (isTrackingStarted) return;
  isTrackingStarted = true;

  if (Native.isApp) {
    nativeEventListenerCleanup = onNativeEvent(NATIVE_EVENTS.NETWORK_STATUS_CHANGED, ({ data }) => {
      updateStatus(data);
    });
  } else {
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
  }
};

const stopNetworkTracking = () => {
  isTrackingStarted = false;
  if (nativeEventListenerCleanup) {
    nativeEventListenerCleanup();
    nativeEventListenerCleanup = null;
  }
  window.removeEventListener("online", handleOnline);
  window.removeEventListener("offline", handleOffline);
};

const handleOnline = () => updateStatus(true);
const handleOffline = () => updateStatus(false);

export const checkNetworkStatus = async () => {
  // If Android natively pushes updates via onNetworkStatusChanged,
  // we just return the latest tracked state.
  if (!Native.isApp) {
    updateStatus(navigator.onLine);
  }
  return isOnlineGlobal;
};
